/* RESPONSIBLE TEAM: team-proactive-support */
import PanelConfiguration from 'embercom/objects/content-editor/panel-configuration';
import AudienceHeaderConfiguration from 'embercom/objects/content-editor/panels/audience/standard-audience-header-configuration';
import ComponentConfiguration from 'embercom/objects/content-editor/component-configuration';
import { assert } from '@ember/debug';
import StandardAudienceEditorConfiguration from 'embercom/objects/content-editor/panels/audience/standard-audience-editor-configuration';
import { contentEditors } from 'embercom/models/data/matching-system/matching-constants';

export default PanelConfiguration.extend({
  init(inputs) {
    // The container gives us access to Services in these objects. Pass `container: getOwner(this)` as an
    // input when generating these configuration objects.
    assert('You must provide the application container in your panel inputs', inputs.container);

    let header = AudienceHeaderConfiguration.create(
      {
        title: inputs.title,
        hideMatchBehavior: true,
      },
      { container: inputs.container },
    );

    let body = ComponentConfiguration.create({
      allowedUserRoles: inputs.allowedUserRoles,
      component: 'content-editor/panels/audience/body',
      showMatchBehavior: false,
      audienceEditorConfiguration:
        inputs.audienceEditorConfiguration ||
        new StandardAudienceEditorConfiguration({
          container: inputs.container,
          showMatchBehavior: false,
          showSendToUnsubscribedToggle: true,
          showAudiencePreview: false,
          showEventRules: false,
          showDateEvents: false,
          showClientPredicates: false,
          hideAddRule: true,
          showImplicitPredicates: false,
          showRolePredicates: false,
        }),
    });
    this._super({
      name: 'audience',
      header,
      body,
      supportedEditors: [contentEditors.series],
    });
  },
});
